export function partnerGalleryImageUrls(partner) {
    return [...partner?.galleryItems || []]
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map(item => item.imageUrl)
        .filter(Boolean);
}

export function partnerSpecialBadgeName(partner) {
    return (partner?.specialBadgeName || '').trim();
}
